// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading___3vACX","load":"load___vcBqD","rotate":"rotate___1xSK1"};